import Player from "@/components/Player";
import DefaultLayout from "@/layouts/default";

function index() {
  return (
    <>
      <DefaultLayout>
        <Player />
      </DefaultLayout>
    </>
  );
}

export default index;
